import { colourOf, fmtTime, weatherLook } from "./palette";

const label = (iso) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString(undefined, { weekday: "short", day: "numeric" });

export const WeekStrip = ({ days, events, reminders, weather, holidays, accent, clock, picked, todayISO, onPick }) => (
  <div className="mt-6 rounded-3xl border border-white/10 bg-panel p-5 sm:p-7" data-testid="week-strip">
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-7">
      {days.map((day) => {
        const sky = weather[day];
        const Look = sky ? weatherLook(sky.code) : null;
        const mine = events.filter((e) => e.day === day);
        const notes = reminders.filter((r) => r.day === day);
        const feast = holidays?.[day];
        return (
          <button
            key={day}
            onClick={() => onPick(day)}
            data-testid={`week-day-${day}`}
            aria-label={`${label(day)}${feast ? `, ${feast}` : ""}`}
            className="min-h-[150px] rounded-xl border p-2 text-start align-top transition-colors"
            style={{
              borderColor: picked === day ? accent : day === todayISO ? `${accent}99` : "rgba(255,255,255,.10)",
            }}
          >
            <span className="flex items-center justify-between gap-1">
              <span className="text-[11px] font-semibold uppercase tracking-wide text-ink-soft">{label(day)}</span>
              {Look && (
                <span className="flex items-center gap-0.5" title={Look.label}>
                  <Look.Icon className="h-3.5 w-3.5" style={{ color: Look.tint }} />
                  <span className="text-[10px] tabular-nums text-ink-soft">{sky.max}°</span>
                </span>
              )}
            </span>
            {feast && (
              <span className="mt-1 block truncate text-[10px] font-semibold text-violet-300"
                    data-testid={`week-holiday-${day}`}>
                {feast}
              </span>
            )}
            <span className="mt-2 block space-y-1">
              {mine.map((ev) => (
                <span
                  key={`${ev.event_id}-${ev.day}`}
                  className="block rounded-md px-1.5 py-1 text-[10px] font-semibold leading-tight text-page"
                  style={{ backgroundColor: colourOf(ev.colour) }}
                  title={ev.title}
                >
                  {ev.all_day ? "All day" : fmtTime(ev.start, clock)} · <span dir="auto">{ev.title}</span>
                </span>
              ))}
              {notes.map((r) => (
                <span key={r.reminder_id}
                      className={`block truncate text-[10px] ${r.done ? "text-ink-soft line-through" : "text-ink-soft"}`}>
                  • <span dir="auto">{r.text}</span>
                </span>
              ))}
              {!mine.length && !notes.length && (
                <span className="block text-[10px] text-ink-soft opacity-60">Nothing yet</span>
              )}
            </span>
          </button>
        );
      })}
    </div>
  </div>
);
